import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { useResponsiveDialog } from "../../../../../Context/ResponsiveDialogContext";
import { getValidationRules, isFieldRequired } from "../PreLoan";

export default function StepContract() {
    const { control, formState: { errors } } = useFormContext();
    const { containerWidth } = useResponsiveDialog();

    const isSmall = containerWidth > 0 && containerWidth < 500;
    const stepKey = 'contrato'; // Definir el stepKey para este componente

    // Debug adicional

    return (
        <div className="p-fluid">
            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Vigencia (meses) {isFieldRequired('contrato.vigenciaMeses', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    {(() => {
                        const rules = getValidationRules('contrato.vigenciaMeses', stepKey);
                        return (
                            <Controller name="contrato.vigenciaMeses" control={control} rules={rules} render={({ field }) => (

                        <InputText {...field} className="w-full" />
                    )} />
                        );
                    })()}
                    {errors.contrato?.vigenciaMeses && <small className="p-error">{errors.contrato.vigenciaMeses.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Fecha de inicio del primer pago {isFieldRequired('contrato.fechaPrimerPago', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    {(() => {
                        const rules = getValidationRules('contrato.fechaPrimerPago', stepKey);
                        return (
                            <Controller name="contrato.fechaPrimerPago" control={control} rules={rules} render={({ field }) => (
                        <Calendar
                            name={field.name}
                            value={field.value}
                            onChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            style={{
                                borderRadius: '17px',
                                overflow: 'hidden',
                                padding: '0',
                                width: '300px',
                                // height: '47px',
                                '& input': {
                                    padding: '0.5rem 1rem',
                                    borderRadius: '0px',
                                }
                            }} panelStyle={{
                                borderRadius: '17px'
                            }} className="w-full" dateFormat="yy-mm-dd" showIcon                         />
                    )} />
                        );
                    })()}
                    {errors.contrato?.fechaPrimerPago && <small className="p-error">{errors.contrato.fechaPrimerPago.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Tasa de int. moratoria diaria {isFieldRequired('contrato.tasaMoratoriaDiaria', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    {(() => {
                        const rules = getValidationRules('contrato.tasaMoratoriaDiaria', stepKey);
                        return (
                            <Controller name="contrato.tasaMoratoriaDiaria" control={control} rules={rules} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                        );
                    })()}
                    {errors.contrato?.tasaMoratoriaDiaria && <small className="p-error">{errors.contrato.tasaMoratoriaDiaria.message}</small>}
                </div>
            </div>
        </div>
    );
}


